import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { CONFIG_INK, modalDeletePaperSx, modalHeaderSx } from "../melhor-envio.theme";

type Props = {
  open: boolean;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function MelhorEnvioDeleteDialog({
  open,
  deleting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{ sx: modalDeletePaperSx }}
    >
      <Box sx={{ ...modalHeaderSx, borderBottomColor: "error.main" }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={1.5} alignItems="center">
            <DeleteOutlineIcon sx={{ fontSize: 28 }} />
            <Typography variant="h6" fontWeight="bold">
              Remover integração
            </Typography>
          </Stack>
          <IconButton onClick={onClose} sx={{ color: "inherit" }} aria-label="Fechar">
            <CloseIcon />
          </IconButton>
        </Stack>
      </Box>

      <MDBox p={3}>
        <MDTypography variant="body2" color="text.secondary">
          Tem certeza que deseja remover as configurações do Melhor Envio? Cotar frete e
          gerar etiquetas deixarão de funcionar até uma nova configuração.
        </MDTypography>
      </MDBox>

      <MDBox px={3} py={2} display="flex" justifyContent="flex-end" gap={1} borderTop="1px solid" borderColor="grey.200">
        <MDButton variant="outlined" color="dark" onClick={onClose} disabled={deleting}>
          Cancelar
        </MDButton>
        <MDButton variant="gradient" color="error" onClick={onConfirm} disabled={deleting}>
          {deleting ? "Removendo…" : "Remover configuração"}
        </MDButton>
      </MDBox>
    </Dialog>
  );
}
